var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('settings-list',{attrs:{"name-header-text":_vm.$i18n.t('label.employee_name'),"store-entities":_vm.$tstore.state.settings.employees,"name-field":"name","on-save":_vm.save,"on-add":_vm.add,"on-is-changed-change":_vm.isChangedChange,"no-data-text":_vm.$t('label.no_employee_names')}})
}
var staticRenderFns = []

export { render, staticRenderFns }